import React from "react";
import { Link } from "react-router-dom";

function PositionTable({ data }) {
  return (
    <div className="pageTable">
      {/* <div className="tableLength">
        <div className="dataTables_length">
          <select className="form-select">
            <option>10</option>
            <option>25</option>
            <option>50</option>
            <option>100</option>
          </select>
          <span className="record">records</span>
        </div>
      </div> */}
      <table className="table table-striped table-bordered ">
        <thead>

          <tr role="row" className="heading">
            <th>#</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Platform</th>
            <th>Browser</th>
            <th>Login At</th>
            <th>Logout At</th>
            {/* <th>Browser | OS</th> */}
          </tr>
        </thead>
        <tbody>

          {data && data?.map((item, i) => {
            return <tr key={i}>
              <td>{i + 1}</td>
              <td>{item?.userId?.firstname}</td>
              <td>{item?.userId?.lastname}</td>
              <td>{item?.userId?.email}</td>
              <td>{item?.platform}</td>
              <td>{item?.browser}</td>
              <td>{item?.createdAt}</td>
              <td>{item?.logout_time}</td>
            </tr>
          })}

        </tbody>
      </table>
    </div>
  );
}

export default PositionTable;
